document.addEventListener('DOMContentLoaded', () => {
	let swiper = null;

	function initSwiper() {
		swiper = new Swiper(".page-slider", {
			slidesPerView: "auto",
			spaceBetween: 30,
			freeMode: true,
			slideToClickedSlide: true,
			centeredSlides: true,
			simulateTouch: false,
			touchStartPreventDefault: false,
			mousewheel: {
				enabled: true,
				sensitivity: 1,
			}
		});
	}

	function toggleSwiper(enable) {
		if (swiper !== null) {
			if (enable) {
				swiper.enable();
			} else {
				swiper.disable();
			}
		}
	}

	function handleCtrlKey(event) {
		if (event.key === 'Control') {
			toggleSwiper(!event.ctrlKey);
		}
	}

	document.addEventListener('keydown', handleCtrlKey);
	document.addEventListener('keyup', handleCtrlKey);

	if (window.innerWidth >= 1025) {
		initSwiper();
	} else {
		$('.page-slider').removeClass('swiper');
		$('.page-slider .swiper-wrapper').removeClass('swiper-wrapper');
		$('.page-slider .swiper-slide').removeClass('swiper-slide');
	}
});